export default __webpack_public_path__ + "static/media/080_finish_soso.first.a39ffb10.avif";